module.exports = __webpack_public_path__ + "img/file-download-01.37260a66.svg";